import axios from 'axios';

export default {
  getSubscribeChannel (second, page) { // 구독중인 채널 목록
    return new Promise((resolve, reject) => {
      axios.get(`/v4/subscribe/channel`, {params: {
          time: second,
          page,
          count: 10,
          type: 'community', // 커뮤니티만
        }}).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getSubscribePost (second, page) { // 구독중인 채널의 읽지 않은 포스트 카운터 & 포스트 목록
    return new Promise((resolve, reject) => {
      axios.get(`/v4/subscribe/post`, {params: {
          time: second,
          page,
          count: 10,
          type: 'community', // 커뮤니티만
        }}).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getChannelEdit () { // 구독중인 채널 순서 등 수정용 목록
    return new Promise((resolve, reject) => {
      axios.get(`/v4/channel/edit`, {params: {
          type: 'community', // 커뮤니티만
        }}).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postChannelEdit (subscribe_channels, unsubscribe_channels) { // 구독중인 채널 순서 등 수정
    return new Promise((resolve, reject) => {
      axios.post(`/v4/channel/edit`, {
        subscribe_channels,
        unsubscribe_channels
      }).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  }
}
